const now = new Date();
export const defaultConfigState = {
  /**
   * Cờ đang xử lý
   */
  Loading: false,
  /**
   * Token đăng nhập
   */
  Token: null,
  /**
   * Thời điểm  token hết hạn
   */
  TokenExpired: null,
  /*
   * Trạng thái Collapse của left menu
   */
  LeftMenuCollapse: false,
  /**
   * Thông tin phân quyền
   * Key là subsystemCode, value sẽ là mảng string danh sách perrmission
   */
  Permission: {},
  /**
   * Thông tin thuê bao
   */
  License: {},
  /**
   * Thông tin tài khoản
   */
  User: {
    UserID: null,
    Email: null,
    FullName: null,
    Mobile: null,
    UserName: null,
  },
  /**
   * Thông tin config
   */
  ConfigInfo: {
    CurrentDate: new Date(now.getFullYear(), now.getMonth(), now.getDay()),
    CurrentDateText: '',
  },
  /**
   * Định dạng số
   */
  NumberFormat: {
    GeneralDecimalSeparator: ',',
    GeneralGroupSeparator: '.',
    QuantityDecimalDigits: 1,
    AmountDecimalDigits: 0,
    AmountOCDecimalDigits: 2,
    UnitPriceDecimalDigits: 1,
    UnitPriceOCDecimalDigits: 1,
    ExchangRateDecimalDigits: 2,
    CoefficientDecimalDigits: 2,
    AllocationDecimalDigits: 2,
  },
  OptionsData: {},
  /**
   * Ngôn ngữ hiện tại
   */
  Culture: 'vi',
  /**
   * Ngày hạch toán
   */
  PostedDate: new Date(),
  /**
   * Một số thông tin liên quan đến phiên làm việc hiện tại
   * Chỉ có 1 số thông tin ở đây, 1 số thông tin khi submit lên server sẽ lấy từ token: userid, databaseid, tenantid...
   */
  Context: {},
  /**
   * Disabled một số trường khi đang trong quá trình chuyển đổi dữ liệu
   */
  IsDisabledConvert: false,
  /**
   * Disabled một số trường khi db đang bận
   */
  IsDisabledBusyDatabase: false,
  /**
   * Tiến trình tạo dữ liệu
   * NVTUAN1 30.08.2024
   */
  CreateDataProcess: null,
  /**
   * Các database đang convert
   */
  DatabaseConverting: [],
  /**
   * Thông tin chuyển đổi cuối
   */
  LastConvertQueue: null,
  /**
   * Các database convert bị lỗi
   */
  DatabaseConvertError: [],
  /**
   * Các database trong đơn vị
   */
  TenantDatabases: [],

  /**
   * Thời gian lần cuối bấm nút chuyển đổi
   */
  LastTimeConvert: [],

  /**
   * Quá trình chuyển đổi của các dữ liệu
   */
  ConvertProgress: [],

  /**
   * Các database đang phục hồi
   */
  DatabaseRestoring: [],

  /**
   * Các database đang sao lưu
   */
  DatabaseBackuping: [],

  /**
   * Đánh dấu xem báo cáo từ phần hệ nào
   * dqdat1 15/05/2023
   */
  GroupId: null,

  /**
   * Cập nhật trạng thái sao lưu thành công
   * ntloc 29/05/2023
   */
  BackUpSuccess: false,

  /**
   * Tiến trình sao chép dữ liệu các db
   */
  CopyDataProgress: [],
  /**
   * Các database đang Sao chép dữ liệu
   */
  DatabaseCopyData: [],
  /*
   * Trạng thái phóng to Tính năng mới
   */
  NewFeatureZoom: true,
  /**
   * Trạng thái thu phóng hướng dẫn quyết toán nhanh
   */
  HelpSettlemenZoom: 1,
  /*
   * Phiên bản Tính năng mới
   */
  VersionNewFeature: '',
  /**
   * Check số lượng người dùng
   */
  IsCheckOverUser: true,
  /**
   * Kết quả sắp xếp số chứng từ
   */
  SortRefNoResult: [],

  /**
   * Có thông báo sự cố bảo trì trên thanh header không?
   * NVTUAN1 23.05.2024
   */
  MISANotifyHeader: false,

  /*
   * Có bật class thỏa thuận mua hàng kh
   */
  MISAAgreementPurchase: false,
  /*
   * Form cập nhật thông tư có đè lên chatbot không
   */
  IsPressChatbot: false,
};

export default {
  ...defaultConfigState,
};
